module.exports = __webpack_public_path__ + "3c60f601930655995ab4d38962466fc4.png";